import {
  getSummarySubTotals,
  usePricing,
} from '@customink/project-service-react-components';
import Big from 'big.js';

export const useHasSignificantVolumeDiscount = () => {
  const { data: pricingData } = usePricing();

  if (!pricingData?.grouped) return false;

  const groupedQuoteCount = Object.keys(pricingData?.grouped).length;
  const meanVolumeDiscountPercentage =
    groupedQuoteCount > 0
      ? Big(
          getSummarySubTotals(
            pricingData.grouped,
            'volume_discount_percentage',
          ),
        ).div(groupedQuoteCount)
      : Big(0);

  const isVolumeDiscountSignificant = meanVolumeDiscountPercentage.gt(Big(0.1));

  return isVolumeDiscountSignificant;
};
